import {
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  HStack,
  SortIcon,
  HbFilter,
} from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { update } from '../../../layout/actions/layout.actions';
import { sortingStrategySelector } from '../../../layout/selectors/layout.selectors';
import { SortingStrategy } from '../../clustering.types';
import { pinnedIdSelector } from '../../../beats/beats.selector';

const SORTING_ITEMS = [
  'Time',
  'RR before',
  'RR after',
  'Prematurity',
  'Compensatory rest',
] as SortingStrategy[];
const DISTANCE_TO_PIN_ITEM = 'Distance to pinned beat' as SortingStrategy;

export const SortingDropdown: React.FC = () => {
  const dispatch = useDispatch();
  const sortingStrategy = useSelector(sortingStrategySelector);
  const pinnedBeatId = useSelector(pinnedIdSelector);

  const onChangeSortingStrategy = useCallback(
    (value: SortingStrategy) => {
      dispatch(update({ update: { sortingStrategy: value } }));
    },
    [dispatch],
  );

  return (
    <HStack>
      <SortIcon size='s' />
      <Text textStyle='label'>Sort by:</Text>
      <Menu>
        <MenuButton as={HbFilter} value={sortingStrategy} />
        <MenuList>
          <MenuOptionGroup
            type='radio'
            onChange={(v) => onChangeSortingStrategy(v as SortingStrategy)}
            value={sortingStrategy}
          >
            {SORTING_ITEMS.map((item) => (
              <MenuItemOption key={item} value={item}>
                {item}
              </MenuItemOption>
            ))}
            {pinnedBeatId != null && (
              <MenuItemOption
                key={DISTANCE_TO_PIN_ITEM}
                value={DISTANCE_TO_PIN_ITEM}
              >
                {DISTANCE_TO_PIN_ITEM}
              </MenuItemOption>
            )}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </HStack>
  );
};
